import React from 'react';
// import Row from 'react-bootstrap/Row';
// import Col from 'react-bootstrap/Col';
// import Container from 'react-bootstrap/Container';

function Resume() {
    return (
        <h3 className= "flex-row">CAREER SUMMARY:
        <br></br>
        Engineer/ Web Developer with a core value of integrity and 3 years software development experience creating ANSYS and ICEM macros while as a CFD engineer at Voith Hydro using the programming languages, Tcl, Linux, and Perl. An additional one year of non-professional experience in full stack web development.  Applying a Masters Degree in Engineering from Penn State towards web development for both, client and server sides. 10 years mechanical engineering industry experience with CFD and FEA. Certified Engineer In Training. Agile / Scrum experience developing MVP in sprints during coding bootcamp with daily stand ups with team members. Ability to learn new languages as needed and to work independently or as part of a team. 
        <br></br>
        <br></br>
        TECHNICAL SKILLS 
        <br></br>
        Languages: JavaScript, SQLite3, MySQL, HTML, CSS,  Sequelize, Node, Markdown, Perl, Tcl, Linux, FORTRAN, C++
        Applications: CSS Grid Layout, Version Control Software Git (GitHub and GitBash), jQuery, Express, Bootstrap, HTML DOM Manipulation, Insomnia, Heroku, Moment.js, Object Oriented Programming (OOP), Unit Testing and Test Driven Development, Jest, Google Map API, Materialize Modals, ANSYS CFX : CFXPre, CFXPost and CFXSolve, ANSYS Workbench, Design Modeler, ICEM CFD, Unigraphics (NX), Solid Edge, Fluent, FloEFD, NoSQL MongoDB, Mongoose, React, Redux, Graphql, Microsoft Visual Studio IDE, MVC, Matlab, REST API’s, JSON
        <br></br>
        <br></br>
        WEB DEVELOPMENT PROJECTS 
        <br></br>
        <br></br>
        Weather API | Deployed App: https://dancl6.github.io/Weather_API/ | 
        <br></br>
        GitHub Repository: https://github.com/dancl6/Weather_API  
        <br></br>
        Web application that returns current weather and five-day forecast for a given city using a weather API
        <br></br>
        Role in Project: Responsible for front-end HTML, CSS and Bootstrap and back-end API calls.
        Technologies Used: Open Weather API, HTML, CSS,  JavaScript, Bootstrap. 
        <br></br>
        <br></br>
        Tech Stop N Shop |Deployed App:  ​https://fathomless-plains-18692.herokuapp.com/
        <br></br>
        ​GitHub Repository: https://github.com/dancl6/TechStopNShop-Enhancement
        <br></br>
        Full Stack E-commerce web application that allows users to browse and purchase items and modify inventory. 
        <br></br>
        Role in Project: Responsible for MySQL database creation, API calls for sign-up, and back-end and front-end implementation of profit page and inventory page for read/write access. 
        Technologies Used: Node.js, HTML, CSS, Bootstrap, MySQL, Express, Handlebars, Dot-env, Bcrypt, URL Shortly, Dark-mode, Sequelize, j-Query, Passport.js. Also responsible for
        enhancement, connecting the front-end to the back-end after checkout.
        <br></br>
        <br></br>
        RELEVANT EXPERIENCE 
        <br></br>
        Lead Design Engineer 				,		October 2019 to  February 2020,
        Teledyne Energy Systems			,				Hunt Valley, MD
        <br></br>
        <br></br>   
        Company provides energy generation equipment. 
        Thoroughly reviewed ASME BPVC Section VIII code for the 2019 version determining whether any designs were impacted. 
        Built a computational model in Fluent, solving for the temperature and flow of fluid (thermal fluid model) for a military application. Used Ansys Workbench to solve for the temperature and structural stress (thermal mechanical model), looking at CTE mismatch for a space vehicle application. Where possible, validated simulations with hand calculations for Heat Transfer and Stress Analysis. 
        <br></br>
        <br></br>
        Structural Analysis Engineer  		,				May 2017 to April 2018,
        Voith Hydro	 					,				York, PA 
        <br></br>
        <br></br>  
        Company designs and manufactures hydro-turbines. 
        Performed Static FEA of hydraulic turbine components to validate safety and to design for performance improvements using High Performance Computing (HPC) for simulations with ANSYS Workbench. Wrote reports and gave presentations to internal customers within the engineering department
        <br></br>
        <br></br>
        CFD Engineer					,				June 2008  to May 2017 ,
        Voith Hydro						,				York, PA   
        <br></br>
        <br></br>
        Company designs and manufactures hydro-turbines. 
        Supported Hydraulic Engineering department with the manual creation of solid model geometries, meshes and CFD simulations using the software Unigraphics (NX), ICEM and CFX, respectively, for all hydro-turbine components including the spiral case, stay vanes, wicket gates, runner and draft tube, for the existing machine or for improvements in performance. 
        Implemented coding and automation of CFD processes using several programming languages, including Tcl, Linux and Perl. 
        Mentored a new hire on the CFD team.
        <br></br>
        <br></br>
        
        EDUCATION
        <br></br>
        <br></br> 
        University of California, Berkeley Extension: Full Stack Web Development Coding Bootcamp, August 2020 
        <br></br>
        Pennsylvania State University: Master’s Degree, Mechanical Engineering,  
        <br></br>
        New Jersey Institute of Technology: Bachelor’s Degree, Mechanical Engineering,
        
        

        </h3>
    )
}

export default Resume;